import { render, staticRenderFns } from "./AddEditStaffGroupForm.vue?vue&type=template&id=b0006fd8&"
import script from "./AddEditStaffGroupForm.vue?vue&type=script&lang=js&"
export * from "./AddEditStaffGroupForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports